import { Component, ElementRef, ViewChild } from '@angular/core';
import { PageBase } from 't4core';
import { T4DatatableWidget } from '../../../../t4common/';


@Component({
  selector: 'notes',
  styleUrls: ['./notes.css'],
  templateUrl: './notes.html',
})
export class NotesTableComponent extends PageBase {
  @ViewChild("tblNotes", { static: false }) private tblNotes: T4DatatableWidget;

  public isAdmin: boolean = false;

  constructor(el: ElementRef) {
    super(el, "NotesTable");
  }


}
